interface Config {
  readonly gameSocketUrl: string;

  readonly apiBaseUrl: string;
}

function readEnv(key: string): string | undefined {
  const value = (import.meta.env as Record<string, string | undefined>)[key];
  return value !== undefined && value !== '' ? value : undefined;
}

function sameOriginGameSocketUrl(): string | undefined {
  if (typeof location === 'undefined' || location.host === '') {
    return undefined;
  }
  return `${location.protocol === 'https:' ? 'wss:' : 'ws:'}//${location.host}/ws`;
}

const gameSocketUrl = readEnv('VITE_GAME_SOCKET_URL') ?? sameOriginGameSocketUrl();
const apiBaseUrl = readEnv('VITE_API_BASE_URL');

if (import.meta.env.PROD && gameSocketUrl === undefined) {
  console.error(
    'No game socket URL: neither VITE_GAME_SOCKET_URL nor a document origin. ' +
      'Falling back to localhost, which will not work anywhere but this machine.',
  );
}

export const config: Config = {
  gameSocketUrl: gameSocketUrl ?? 'ws://127.0.0.1:55666',
  apiBaseUrl: apiBaseUrl ?? '',
};
